import React from 'react';
import FormComponent from "../../common/FormComponent";
import Validators from "../../constants/ValidatorTypes";
import { addTypeface } from "../../services/typeface/TypefaceService";
import TypefaceForm from "../../components/forms/typeface/TypefaceForm";
import strings from "../../localization";
import Grid from '@material-ui/core/Grid';
import { Paper } from "@material-ui/core";
import { bindActionCreators } from 'redux';
import connect from "react-redux/es/connect/connect";
import * as Actions from '../../actions/Actions';
import { withSnackbar } from 'notistack';
import { withRouter } from "react-router-dom";

class AddTypeface extends FormComponent {

  validationList = {
    name: [{ type: Validators.REQUIRED }]
  };

  constructor(props) {
    super(props);

    this.state = {
      data: props.data ? props.data : {},
      errors: {}
    };

    this.props.changeFullScreen(false);
    this.submit = this.submit.bind(this);

  }

  submit() {
    if (!this.validate()) {
      return;
    }

    this.showDrawerLoader();

    addTypeface(this.transformRequest(this.state.data), this.props.cid).then(response => {
      if (!response.ok) {
        let messageKey = response.response.data.message;

        this.props.enqueueSnackbar(strings.typeface.messages[messageKey], { variant: "error" });

        this.handleError(messageKey);

        return;
      }
      this.props.enqueueSnackbar(strings.addTypeface.added, { variant: 'success' });
      this.props.onFinish(response.data);
      this.hideDrawerLoader();
    });
  }

  transformRequest(data) {
    return {
      ...data,
      userEmail: this.props.uemail,
      companyId: this.props.cid
    }
  }

  handleError(message) {
    switch (message) {
      case "TYPEFACE_WITH_NAME_ALREADY_EXIST":
        this.setError("name", strings.typeface.messages.TYPEFACE_WITH_NAME_ALREADY_EXIST);
        break;
      case "TYPEFACE_NOT_EXIST":
        this.setError("name", strings.typeface.messages.TYPEFACE_NOT_EXIST);
        break;
      case "TYPEFACE_NAME_CANT_BE_NULL":
        this.setError("name", strings.typeface.messages.TYPEFACE_NAME_CANT_BE_NULL);
        break;
    }
  }

  render() {

    return (
      <Grid id='page' item md={12}>

        <div className='header'>
          <h1>{strings.addTypeface.pageTitle}</h1>
        </div>

        <Paper className='paper'>
          <TypefaceForm
            onChange={this.changeData}
            onSubmit={this.submit}
            data={this.state.data}
            errors={this.state.errors}
            onCancel={this.props.onCancel} />
        </Paper>

      </Grid>
    );
  }

}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    changeFullScreen: Actions.changeFullScreen
  }, dispatch);
}

function mapStateToProps({ menuReducers, siteDataReducers }) {
  return { menu: menuReducers, siteData: siteDataReducers };
}

export default withSnackbar(withRouter(connect(mapStateToProps, mapDispatchToProps)(AddTypeface)));
